import { FC, useRef, useState } from "react";
import CustomButton from "ui/Button";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { FilterOption } from "interface";
import { addWeeks, startOfDay } from "date-fns";
import DatePickerComponent from "ui/Date";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: FilterOption) => void;
	filterOptions: FilterOption;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const [localFromDate, setLocalFromDate] = useState(filterOptions.fromDate);
	const [localToDate, setLocalToDate] = useState(filterOptions.toDate);
	const pendingFromDate = useRef(filterOptions.fromDate);
	const pendingToDate = useRef(filterOptions.toDate);

	const minDate = startOfDay(addWeeks(new Date(), -1));
	const maxDate = startOfDay(new Date());

	const isInRange = (date: Date | null | undefined) => {
		if (!date) return false;
		const d = startOfDay(new Date(date));
		return d >= minDate && d <= maxDate;
	};

	const isSameDate = (a: Date | null | undefined, b: Date | null | undefined) => {
		if (!a || !b) return a === b;
		return startOfDay(a).getTime() === startOfDay(b).getTime();
	};

	const applyFromDate = (value = pendingFromDate.current) => {
		if (isSameDate(value, filterOptions.fromDate)) return;
		if (!isInRange(value)) return;
		setFilterOptions({
			...filterOptions,
			fromDate: value,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyToDate = (value = pendingToDate.current) => {
		if (isSameDate(value, filterOptions.toDate)) return;
		if (!isInRange(value)) return;
		setFilterOptions({
			...filterOptions,
			toDate: value,
			take: props.pageSize,
			skip: 0,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items fresh-sales-filter-items">
				<div className="fresh-sales-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={localFromDate}
						max={maxDate}
						min={minDate}
						onChange={(e) => {
							pendingFromDate.current = e.value;
							setLocalFromDate(e.value);
							if (e.syntheticEvent?.type === "click") {
								applyFromDate(e.value);
							}
						}}
						onBlur={() => applyFromDate()}
					/>
				</div>
				<div className="fresh-sales-filter-field" style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={localToDate}
						max={maxDate}
						min={minDate}
						onChange={(e) => {
							pendingToDate.current = e.value;
							setLocalToDate(e.value);
							if (e.syntheticEvent?.type === "click") {
								applyToDate(e.value);
							}
						}}
						onBlur={() => applyToDate()}
					/>
				</div>

				{/* <div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer: Buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id as any,
								buyerName: buyer.name,
								buyerLedgerNumber: buyer.id as any,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							displayName: filterOptions.buyerName || t("ChooseBuyer"),
						}}
						dataItemKey="id"
						textField="displayName"
						label={t("Buyer")}
						defaultItem={{ id: "id", displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div> */}
			</div>

			<div className="filter-end-btn fresh-sales-filter-end-btn">
				<CustomButton
					label={"PDF"}
					onClick={() => exportAsPDF()}
					iconName={ICON_NAMES.Download}
				/>
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
